<div #sharedListContainer *ngIf="showSharedList" >
    <div class="save-to-list-ctnr-main">

        <div class="save-to-list-action" >
            <span class="save-to-list-text" (click)="toggleSaveToList()">Save to list</span>
            <span class="info-icon-ctrn" (click)="openAbout()" >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                    <path
                        d="M9,4c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S6.2,4,9,4 M9,2C5.1,2,2,5.1,2,9s3.1,7,7,7s7-3.1,7-7 c0-1.9-0.7-3.6-2.1-4.9S10.9,2,9,2z M8,8.5v4.4h2V8.5H8z M8,5.2v2h2v-2H8z">
                    </path>
                </svg>
            </span>
        </div>

        <div class="save-to-list">
            <tf-shared-list-popper *ngIf="visible"
                                   [assay]="assay"
                                   (onItemAddedToList)="onItemAddedToListHandler($event)">
            </tf-shared-list-popper>
        </div>

    </div>
</div>
